<!-- 待售专利资产 -->
<template>
  <div class="development">
    <div class="banner">
      <div class="content">
        <div class="search">
          <input
            type="text"
            v-model="searchParams.keyword"
            placeholder="请输入关键词"
            @keyup.enter="handleSearch"
          />
          <button @click="handleSearch">
            <img src="../assets/search_icon.png" alt="" />搜索
          </button>
        </div>
        <div class="query">
          <div class="categories">
            <!-- 动态渲染分类 -->
            <div
              class="category-group"
              v-for="(category, index) in categories"
              :key="index"
            >
              <h3>{{ category.title }}</h3>
              <ul>
                <li
                  v-for="(item, i) in category.items"
                  :key="i"
                  :class="{
                    active: activeItems[index] === i,
                    'default-active':
                      i === 0 && !activeItems.hasOwnProperty(index),
                  }"
                  @click="selectItem(index, i)"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="content">
        <div class="main_box">
          <div class="header">
            <div class="sort">
              <el-dropdown trigger="click" @command="handleSortChange">
                <span class="el-dropdown-link">
                  {{ currentSort
                  }}<img src="../assets/bottomArrow.png" alt="" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in sortOptions"
                    :key="item"
                    :command="item"
                  >
                    {{ item }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="result">
              <p>搜索结果：</p>
              共有
              <p>{{ total }}</p>
              个结果
            </div>
            <div class="reset" @click="resetSearch">
              <i class="el-icon-refresh-right"></i>
              <p>重置搜索</p>
            </div>
          </div>
          <div class="table">
            <table>
              <thead>
                <tr>
                  <th style="width: 9%">授权类型</th>
                  <th>专利类型</th>
                  <th>专利申请号</th>
                  <th style="width: 15%">专利名称</th>
                  <th>专利领域</th>
                  <th style="width: 9%">价格区间</th>
                  <th>案源时间</th>
                  <th>联系方式</th>
                  <th>QQ</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in tableData"
                  :key="index"
                  @click="getPatent(item.id)"
                  style="cursor: pointer"
                >
                  <td style="width: 9%">{{ item.authorization_type }}</td>
                  <td>{{ item.patent_classification }}</td>
                  <td>{{ item.application_number }}</td>
                  <td style="width: 15%">{{ item.title }}</td>
                  <td>{{ item.field }}</td>
                  <td style="width: 9%">
                    {{ formatPrice(item.exclusive_selling_price) }}
                  </td>
                  <td>{{ item.publication_date }}</td>
                  <td>{{ item.user?.tel || "" }}</td>
                  <td>{{ item.user?.qq || "" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="paging">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchParams.page"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="searchParams.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getParams, getPatentSale } from "../api/userApi";
export default {
  data() {
    return {
      searchParams: {
        page: 1,
        limit: 10,
        keyword: "",
        authorization_type: "",
        patent_type: "",
        patent_budget: "",
        sort_field: "",
        sort_type: "",
      },
      tableData: [],
      total: 0,
      currentSort: "按价格排序",
      sortOptions: ["按价格排序", "按发布时间排序"],
      sortField: "exclusive_selling_price", // 默认按人气排序
      sortType: "desc", // 默认降序
      isDescending: true, //标记当前是否是降序
      activeItems: {},
      categories: [
        {
          title: "授权类型：",
          items: ["全部"],
          type: "authorization_type",
          id: [],
          key: "authorization_type",
        },
        {
          title: "专利类型:",
          items: ["全部"],
          type: "patent_type",
          id: [],
          key: "patent_type",
        },
        {
          title: "价格区间：",
          items: ["全部"],
          type: "patent_budget",
          id: [],
          key: "patent_budget",
        },
      ],
    };
  },
  created() {
    this.getParamsData();
    this.fetchPatentData();
  },
  methods: {
    // 排序变化
    handleSortChange(sortOption) {
      // 如果是切换不同排序字段，重置为降序
      if (this.currentSort !== sortOption) {
        this.isDescending = true;
        this.sortType = "desc";
      } else {
        // 如果是同一排序字段，切换排序方向
        this.isDescending = !this.isDescending;
        this.sortType = this.isDescending ? "desc" : "asc";
      }

      this.currentSort = sortOption;
      this.sortField =
        sortOption === "按价格排序" ? "exclusive_selling_price" : "create_time";
      // 更新searchParams中的排序字段
      this.searchParams.sort_field = this.sortField;
      this.searchParams.sort_type = this.sortType;
      this.searchParams.page = 1;
      this.fetchPatentData();
    },
    changeSort(item) {
      this.currentSort = item;
      this.searchParams.sort_field = item.value;
      this.searchParams.sort_type = item.type;
      this.fetchPatentData();
    },
    getParamsData() {
      getParams()
        .then((res) => {
          if (res.code === 1) {
            const data = res.data;

            // 处理授权类型
            this.processCategory(0, data.authorization_type);

            // 处理专利类型
            this.processCategory(1, data.patent_type);

            // 处理价格区间 - 直接使用接口返回顺序
            this.processCategory(2, data.patent_budget);
          }
        })
        .catch((error) => {
          console.error("获取参数失败:", error);
        });
    },

    processCategory(index, apiData) {
      this.categories[index].items = [
        ...this.categories[index].items,
        ...apiData.data.map((item) => item.title),
      ];
      this.categories[index].id = apiData.data.map((item) => item.id);
    },
    fetchPatentData() {
      // 过滤掉空参数
      const params = {
        ...this.searchParams,
        sort_field: this.searchParams.sort_field || this.sortField,
        sort_type: this.searchParams.sort_type || this.sortType,
      };

      getPatentSale(params)
        .then((res) => {
          if (res.code === 1) {
            this.tableData = res.data;
            this.total = res.count;
          }
        })
        .catch((error) => {
          console.error("获取专利数据失败:", error);
        });
    },
    selectItem(categoryIndex, itemIndex) {
      this.$set(this.activeItems, categoryIndex, itemIndex);
      const category = this.categories[categoryIndex];

      Object.keys(this.activeItems).forEach((key) => {
        if (key != categoryIndex) {
          this.$set(this.activeItems, key, 0);
          this.searchParams[this.categories[key].key] = "";
        }
      });

      if (itemIndex === 0) {
        this.searchParams[category.key] = "";
      } else {
        this.searchParams[category.key] = category.id[itemIndex - 1]; // 直接传 id（8）
      }

      this.searchParams.page = 1;
      this.fetchPatentData();
    },
    handleSearch() {
      this.searchParams.page = 1;
      this.fetchPatentData();
    },

    resetSearch() {
      this.searchParams = {
        page: 1,
        limit: 10,
        keyword: "",
        authorization_type: "",
        patent_type: "",
        patent_budget: "",
        sort_field: "",
        sort_type: "",
      };
      this.activeItems = {};
      // this.currentSort = {
      //   label: "默认排序",
      //   value: "",
      //   type: "",
      // };
      this.fetchPatentData();
    },

    getPatent(id) {
      this.$router.push({
        path: "/patent",
        query: { id },
      });
    },

    formatPrice(price) {
      if (!price) return "面议";
      if (price === "8") return "面议";
      return price;
    },

    handleSizeChange(val) {
      this.searchParams.limit = val;
      this.fetchPatentData();
    },

    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.fetchPatentData();
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
  //   position: absolute;
}
.banner {
  //   position: relative;
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
  .content {
    width: 100%;
    max-width: 87.5rem;
    margin: 0 auto;
    position: relative;
    .query {
      position: absolute;
      width: 100%;
      //   height: 294px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      left: 0;
      bottom: -287px;
      padding: 37px 35px;
      box-sizing: border-box;
      .categories {
        display: flex;
        flex-direction: column;
        .category-group {
          //   border-bottom: 1px dashed #d8d8d8;
          background-image: linear-gradient(
            to right,
            #d8d8d8 50%,
            transparent 50%
          );
          background-size: 20px 1px; /* 控制虚线间距：10px 为总长度，50% 透明，50% 实色 */
          background-repeat: repeat-x;
          background-position: bottom; /* 底部边框 */
          display: flex;
          //   padding-left: 20px;
          padding: 20px 0 5px 20px;
          box-sizing: border-box;
          h3 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #121212;
            width: 8%;
            text-align: left;
          }
          ul {
            width: 92%;
            display: flex;
            flex-wrap: wrap;
            li {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              margin-right: 10px;
              margin-bottom: 4px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 3px 10px;
              &.active,
              &.default-active {
                background: #175dc2;
                color: #fff;
                padding: 3px 10px;
                box-sizing: border-box;
              }
            }
          }
        }
        .category-group:last-child {
          background-size: 20px 0px;
        }
        .category-group:first-child {
          padding-top: 0;
        }
      }
    }
  }
  .search {
    padding-top: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      width: 638px;
      height: 50px;
      background: #ffffff;
      border-radius: 9px 0px 0px 9px;
      border: none; /* 移除边框 */
      outline: none;
      padding-left: 25px;
    }
    input::placeholder {
      //   padding-left: 25px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #a9a9a9;
      font-style: normal;
    }
    input:focus {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #121212;
      font-style: normal;
    }
    button {
      cursor: pointer;
      border: none;
      outline: none;
      width: 96px;
      height: 50px;
      background: #c5e1ff;
      border-radius: 0px 9px 9px 0px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #175dc2;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 3px;
      }
    }
  }
}
.main {
  background: #f5f5f5;
  padding-top: 100px;
  padding-bottom: 45px;
  width: 100%;
  .main_box {
    width: 100%;
    // height: 1017px;
    background: #fff;
    border-radius: 10px;
    padding: 15px 40px 35px 40px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .sort {
        width: 124px;
        height: 39px;
        background: #ffffff;
        border: 1px solid #d3d3d3;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin-left: 10px;
        }
        ::v-deep .el-popper ul {
          left: 299px !important;
        }
      }
      .result {
        display: flex;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: rgba(18, 18, 18, 1);
        p {
          color: #175dc2;
        }
      }
      .reset {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 114px;
        height: 39px;
        background: #ffffff;
        border: 1px solid #d3d3d3;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #121212;
        line-height: 20px;
        cursor: pointer;
        i {
          margin-right: 10px;
          line-height: 20px;
        }
      }
    }
    .table {
      //   width: 100%;
      table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse; /* 合并单元格边框 */
        border-spacing: 0; /* 移除单元格之间的间距 */
        margin: 15px 0 35px 0;
        th,
        td {
          /* 强制不换行 */
          white-space: nowrap;
          /* 内容超出容器隐藏 */
          overflow: hidden;
          /* 使用省略号表示被隐藏的内容 */
          text-overflow: ellipsis;
          /* 设置最大宽度或固定宽度 */
          width: 11%; /* 根据实际情况调整 */
          /* 确保内容不会自动扩展td的宽度 */
          // display: inline-block;
          /* 可选：设定一个固定高度，如果适用 */
          height: 50px; /* 根据实际情况调整 */
          line-height: 50px;
        }
        thead {
          border-radius: 5px;
          background: #175dc2;

          tr {
            height: 50px;
            th {
              // width: 10%;
              font-family: PingFang SC, PingFang SC;

              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        tbody {
          tr:nth-child(odd) {
          }
          tr:nth-child(even) {
            background: #f2f4fe;
            border-radius: 5px;
          }
          tr {
            td {
              // height: 50px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              // white-space: nowrap; /* 禁止文字换行 */
              // overflow: hidden; /* 超出部分隐藏 */
              // text-overflow: ellipsis;
            }
          }
        }
      }
    }
    .paging {
      display: flex;
      justify-content: flex-end;
      padding-right: 45px;
    }
  }
}
</style>
